import { useQuery } from "@tanstack/react-query";
import { fetchApi } from "@/lib/api";
import { CLERK_AVAILABLE, getDemoAuthHeaders, getClerkAuthHeaders } from "@/lib/auth";
import { useAuthConditional } from "@/lib/use-auth-conditional";

interface User {
  id: string;
  companyId: string | null;
  defaultCompanyId: string | null;
  clerkUserId: string;
  role: string;
  name: string;
  email: string;
  createdAt: string;
}

interface OnboardingStatusResponse {
  isOnboarded: boolean;
  user: User | null;
}

export function useOnboardingStatus() {
  const auth = useAuthConditional();

  return useQuery({
    queryKey: ["onboarding-status"],
    queryFn: async () => {
      const headers = CLERK_AVAILABLE
        ? await getClerkAuthHeaders(auth.getToken)
        : getDemoAuthHeaders();

      return fetchApi<OnboardingStatusResponse>("/api/onboarding/status", {
        headers,
      });
    },
    enabled: auth.isSignedIn,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}
